import SearchOutlined from '@ant-design/icons/lib/icons/SearchOutlined';
import { useTranslation } from '@framework/i18n';
import { Button, Input, Space } from 'antd';
import * as React from 'react';
import styled from 'styled-components';

const Container = styled.div`
  padding: 8px;
`;
const InputSearch = styled(Input)`
  display: block;
  margin-bottom: 8px;
  width: 188px;
`;
const ButtonHalfSpace = styled(Button)`
  width: 90px;
`;

export interface FilterDropdownSearchProps {}

/**
 * Componente per visualizzare un filtro di ricerca.
 * Al momento contiene solo la rappresentazione grafica.
 */
export function FilterDropdownSearch(props: FilterDropdownSearchProps) {
  const { t } = useTranslation();

  return (
    <Container>
      <InputSearch placeholder="Ricerca" />
      <Space size={8}>
        <ButtonHalfSpace size="small" type="link">
          {t('table.filter-dropdown-search.reset', 'Reset')}
        </ButtonHalfSpace>
        <ButtonHalfSpace type="primary" icon={<SearchOutlined />} size="small">
          {t('table.filter-dropdown-search.search', 'Cerca')}
        </ButtonHalfSpace>
      </Space>
    </Container>
  );
}
